import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService, EventType, EventFilter } from '../../services';
import { AppSettings } from '../../app.settings';
import { StringUtility } from "../../util/string.utility";
import { AgentUtility } from "../../util";
import { MeetingsService } from '../../services/meetings.service';
import { AgentsService } from "../../services/agents.service";
import { AppComponent } from "../../app.component";

@Component({
    moduleId: module.id,
    selector: 'events',
    templateUrl: 'events.component.html',
    styles: ['>>> .bold { font-weight: bold; } a {cursor: pointer;}'],
    providers: [EventsService]
})
export class EventComponent {

    public events: any = [];
    public meetings:any = [];
    public eventColor: string;
    public showLoadScreen: boolean = false;
    public eventType = EventType;

    public  complexEvents:any[] = [];
    InitializeComplexEvents(){
        let preparedEvents:any[] = this.events.map(e => {
            return {date:e.EventDate, type:"Event", data:e}
        })
        let preparedMeetings:any[] = this.meetings.map(m => {
            return {date:m.Date, type:"Meeting", data:m}
        })
        this.complexEvents =  preparedEvents.concat(preparedMeetings).sort((ce1,ce2) => {
            return (new Date(ce1.date).getTime() - new Date(ce2.date).getTime());
        });
    }

    @Output() onChangeEventState = new EventEmitter();

    constructor(private _eventsService: EventsService, private router: Router, private meetingsService:MeetingsService, private agentService: AgentsService, private appComponent: AppComponent) {
        this._eventsService.onStart = () => this.showLoadScreen = true;
        this._eventsService.onEnd = () => this.showLoadScreen = false;
    }

    ngOnInit() {
        this.appComponent.checkMeetings();
    }

    eventRowPink(complexEvents) {
        var currentDate = new Date();
        if(complexEvents.type != "Event")
            return "workplace-l-event__row";
        let event = complexEvents.data;
        return (event.EventTypeId == 2 && new Date(event.EventDate).getTime() < currentDate.getTime()) && !(event.Amount != null && (event.DocumentStatusId == 6 || event.DocumentStatusId == 463)) ? "workplace-l-event__row_pink" : "workplace-l-event__row";
    }

    
    private bindPersonLinks(){
        this.meetings.forEach((m,i) => {
            this.meetingsService.getClientInfo(m.Id).subscribe(data => {
                m.Person = data.data.length == 1? data.data[0] : null;
                if(i+1 == this.meetings.length)
                    this.InitializeComplexEvents();
            })
        })
    }


    public bind(filter: EventFilter) {
        this.agentService.getAgent(filter.AgentId).subscribe(data => {
            let dataAgent = data.data;

            this._eventsService.getEvents(filter)
                .subscribe((data) => {
                    this.events = data.data;
                    this.InitializeComplexEvents();
                });

            if(dataAgent != undefined){
                filter.AgentId = dataAgent.ContactId;
            }

            // this.meetingsService.getMeetingsByFilter(filter).subscribe(data => {
            //     this.meetings = data.data;
            //     this.InitializeComplexEvents();
            //     this.bindPersonLinks();
            // })
            if(this.meetings.length == 0){
                this.meetingsService.getMeetingsByFilterLink(filter).subscribe(data => {
                        this.meetings = data.data[0];
                        var seventhDay = new Date();
                        var seventhDay2 = new Date();
                        seventhDay.setDate(seventhDay.getDate() + 7);
                        seventhDay2.setDate(seventhDay2.getDate() - 1);
                        this.meetings = this.meetings.filter((meeting) => {
                            return new Date(meeting.Date).getTime() <= seventhDay.getTime() && new Date(meeting.Date).getTime() >= seventhDay2.getTime()
                        })
                        this.InitializeComplexEvents();
                })
            }
        });
    }

    public bindEventsMeetings(filter: EventFilter){
        this.agentService.getAgent(filter.AgentId).subscribe(data => {
            let dataAgent = data.data;
            if(dataAgent != undefined){
                filter.AgentId = dataAgent.ContactId;
            }
            this.meetingsService.getMeetingsByFilterDate(filter).subscribe(data => {
                this.meetings = data.data[0];
                this.InitializeComplexEvents();
            });
        });
    }

    public bindLocal(data: any[]) {
        this.events = data;
        // let preparedEvents:any[] = this.events.map(e => {
        //     return {date:e.EventDate, type:"Event", data:e}
        // })
        // let preparedMeetings:any[] = this.meetings.map(m => {
        //     return {date:m.Date, type:"Meeting", data:m}
        // })
        // this.complexEvents =  preparedEvents.concat(preparedMeetings).sort((ce1,ce2) => {
        //     return (new Date(ce1.date).getTime() - new Date(ce2.date).getTime());
        // });
        this.complexEvents = this.events.map(e => {
            if(e.EventDate === undefined){
                return {date:e.Date, type:"Meeting", data:e}
            }
                 return {date:e.EventDate, type:"Event", data:e}
             })
    }

    public seeEvent(event) {
        let agent = AgentUtility.getLocalUser();
        let agentId = agent.Id || 123;
        let changeObj = {};
        if (event.IsViewed) {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: null
            }
        } else {
            changeObj = {
                Id: event.Id,
                IsViewed: !event.IsViewed,
                ViewedByAgentId: agentId
            }
        }
        this._eventsService.changeEvent(changeObj).subscribe((data) => {
            event = Object.assign(event, data.data);
            this.onChangeEventState.emit();
        });

    }

    public getPaymentUrl(contract): string {
        return `portfolio/${contract.ContractHeaderId}`;
    }

    public onClientClick(event) {
        localStorage.setItem('filterContracts', JSON.stringify({ PersonId: event.PersonId }));
        this.router.navigateByUrl('portfolio');
    }

    filterPhoneView(str) {
        return StringUtility.PhoneMask(str);
    }
}